// Lib
import { FC, useEffect, useRef } from "react";
// Components
import { TableInfiniteScrollProps } from "components/Table/types";

export const InfiniteScroll: FC<TableInfiniteScrollProps> = ({
  canFetchNextPage,
  fetchNextPage,
}) => {
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // fetch if element in view
    const handleIntersection = (entries: IntersectionObserverEntry[]) => {
      if (entries[0] && entries[0].isIntersecting && canFetchNextPage) {
        fetchNextPage();
      }
    };

    // create observer instance
    // value of '200px' means that the tracking of the element will start
    // when it approaches the visible area by a distance of 200 pixels.
    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      rootMargin: "200px",
      threshold: 0,
    });

    //

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    // cleanup function
    return () => observer.disconnect();
  }, [canFetchNextPage, fetchNextPage]);

  return <div ref={elementRef} />;
};
